// Analytics and tracking.

const isGAEnabled = () => {
  return process.env.REACT_APP_ENVIRONMENT === "production";
};

const isPixelEnabled = () => {
  return process.env.REACT_APP_ENVIRONMENT === "production";
};

export const initGA = () => {
  if (isGAEnabled()) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
  }
};

export const trackGAEvent = (event, params = null) => {
  isGAEnabled() && window.gtag && window.gtag('event', event, params);
};

export const initMetaPixel = () => {
  if (!isPixelEnabled() || window.fbq) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );

  fbq("init", process.env.REACT_APP_META_PIXEL_ID);
  fbq("track", "PageView");
}

export const trackMetaEvent = (event) => {
  isPixelEnabled() && window.fbq && window.fbq('trackCustom', event);
};
